// extracted by mini-css-extract-plugin
var _1 = "VWFBb";
var _2 = "qQdVY";
var _3 = "tya5U";
var _4 = "XGZqa";
var _5 = "bnT_u";
var _6 = "ZUqqy";
var _7 = "ibqRT elide";
var _8 = "tChpv";
var _9 = "RClOW";
var _a = "ljlg6";
var _b = "ltuPg";
export { _1 as "action", _2 as "base", _3 as "detailsDialogBody", _4 as "dismiss", _5 as "hasScrollbar", _6 as "icon", _7 as "message", _8 as "variant-default", _9 as "variant-error", _a as "variant-success", _b as "variant-warning" }
